export default __webpack_public_path__ + "static/media/img_6.a9cc3be9.svg";